import { Link } from 'navigation'
import Image from 'next/image'

const SignUp = ({ t }) => {
  return (
    <>
      <h3 className='font-light text-[30px] md:text-[28px] mb-6 '>
        {t('signUp.title')}
      </h3>
      <p className='font-light mb-6'>
        {t.rich('signUp.goTobusiness', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
          linkToBusinessWeb: (chunks) => (
            <Link target='_blank' className='text-rolzo-gold' href={`https://${chunks}`}>
              {chunks}
            </Link>
          ),
        })}
      </p>
      <div className='mb-6'>
      <Image priority={true}
src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_01.png'
alt=''
width={619}
height={366}
className='w-[75%] h-auto'
/>
</div>
<p className='font-light mb-6'>
        {t.rich('signUp.enterYourFirst', {
          bold: (chunks) => <span className='font-normal'>{chunks}</span>,
        })}
      </p>
      <Image priority={true}
src='https://storage.googleapis.com/rolzo-static-bucket/faq/FAQ_02.png'
alt=''
width={619}
height={366}
className='w-[75%] h-auto'
/>
    </>
  )
}

export default SignUp
